module.exports = __webpack_public_path__ + "static/media/HPNM04.a9524fee.jpg";